import { bffRestClient } from 'APP/restApi/restClient/restClient';

const ROOT_API = 'host';

const hostConfigClient = bffRestClient.createSubApiClient({ rootApi: ROOT_API });

let unauthorizedCallHostConfigClient: ReturnType<typeof bffRestClient.createSubApiClient> | null =
  null;

export const initUnauthorizedCallHostConfigClient = (baseUrl: string): void => {
  unauthorizedCallHostConfigClient = bffRestClient.createSubApiClient({
    rootApi: ROOT_API,
    baseUrl: `${baseUrl}/api/v1`,
  });
};

export function getHostConfig(): Promise<ArrayBuffer> {
  return hostConfigClient.post('', {}, 'getHostConfigRequest');
}

export const getUnauthorizedCallHostConfig = (): Promise<ArrayBuffer> => {
  if (!unauthorizedCallHostConfigClient) {
    throw new Error('unauthorizedCallHostConfigClient must be initiated with correct base url');
  }
  return unauthorizedCallHostConfigClient.post(
    'unauthorized',
    {},
    'getUnauthorizedCallHostConfigRequest'
  );
};
